<template>
  <div>
    <div v-if="Lib.checkPower('beauty-4-ckyysr',2)">
      <el-row>
        <el-date-picker v-model="date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="expireTimeOption" value-format="yyyy-MM-dd" :clearable="false" @change="onChangeTime" />
        <el-select v-model="value" placeholder="请选择" style="margin: 0 10px;">
          <el-option label="按自然日统计" value="1">
          </el-option>
          <el-option label="按营业时间统计" value="2">
          </el-option>
        </el-select>
        <el-tooltip class="item" effect="light" placement="top-start">
          <div slot="content">
            按自然日统计：按0点到24点为一天，进行数据统计<br />
            按营业时间统计：按实际设置的营业时间为一天，进行数据统计
          </div>
          <i class="el-icon-warning" style="color:#D2D2D2;font-size:14px;"></i>
        </el-tooltip>
      </el-row>
      <br />
      <el-container class="container">
        <el-header height="30px" class="header">
          收入数据
          <span>（所选时间段的订单统计）</span>
        </el-header>
        <el-main class="main">
          <li>
            <img src="@/assets/images/income.png" />
            <p>
              消费金额
              <el-tooltip class="item" effect="light" content="指已结算订单的原始金额汇总（不包含任何优惠）" placement="right">
                <i class="el-icon-warning" style="color:#D2D2D2;font-size:13px;"></i>
              </el-tooltip>
            </p>
            <p style="color:#333333;font-weight:bold;">
              <span>￥</span>
              <span style="font-size:24px">{{ Business.incomeMoney }}</span>
            </p>
            <p style="color:#999999;font-size:14px;">{{ Business.incomeNum }}笔</p>
          </li>
          <li>
            <img src="@/assets/images/expenditure.png" />
            <p>
              优惠金额
              <el-tooltip class="item" effect="light" content="指订单使用优惠方式后优惠的金额汇总" placement="right">
                <i class="el-icon-warning" style="color:#D2D2D2;font-size:13px;"></i>
              </el-tooltip>
            </p>
            <p style="color:#333333;font-weight:bold;">
              <span>￥</span>
              <span style="font-size:24px">{{ Business.discountMoney }}</span>
            </p>
            <p class="grey">{{ Business.discountNum }}笔</p>
          </li>
          <li>
            <img src="@/assets/images/expenditure.png" />
            <p>
              划扣金额
              <el-tooltip class="item" effect="light" content="指订单使用套餐、会员卡划扣等金额汇总" placement="right">
                <i class="el-icon-warning" style="color:#D2D2D2;font-size:13px;"></i>
              </el-tooltip>
            </p>
            <p style="color:#333333;font-weight:bold;">
              <span>￥</span>
              <span style="font-size:24px">{{ Business.deductMoney }}</span>
            </p>
            <p class="grey">{{ Business.deductNum }}笔</p>
          </li>
          <li>
            <img src="@/assets/images/expenditure.png" />
            <p>
              应收欠款
              <el-tooltip class="item" effect="light" content="指使用赊账与部分支付未还部分的金额汇总" placement="right">
                <i class="el-icon-warning" style="color:#D2D2D2;font-size:13px;"></i>
              </el-tooltip>
            </p>
            <p style="color:#333333;font-weight:bold;">
              <span>￥</span>
              <span style="font-size:24px">{{ Business.dueMoney }}</span>
            </p>
            <p class="grey">
              <el-tooltip class="item" effect="light" content="指使用赊账的订单的金额汇总" placement="right">
                <i class="el-icon-warning" style="color:#D2D2D2;font-size:13px;"></i>
              </el-tooltip>
              赊账金额：￥{{ Business.creditMoney }}
            </p>
            <p class="grey">{{ Business.creditNum }}笔</p>
            <p class="grey">
              <el-tooltip class="item" effect="light" content="指使用部分支付未还部分的金额汇总" placement="right">
                <i class="el-icon-warning" style="color:#D2D2D2;font-size:13px;"></i>
              </el-tooltip>
              欠款金额：￥{{ Business.debtMoney }}
            </p>
            <p class="grey">{{ Business.dueNum }}笔</p>
          </li>
          <li>
            <img src="@/assets/images/income.png" />
            <p>
              实收金额
              <el-tooltip class="item" effect="light" content="指订单实际收到的金额汇总" placement="right">
                <i class="el-icon-warning" style="color:#D2D2D2;font-size:13px;"></i>
              </el-tooltip>
            </p>
            <p style="color:#333333;font-weight:bold;">
              <span>￥</span>
              <span style="font-size:24px">{{ Business.realMoney }}</span>
            </p>
            <p class="grey">{{ Business.realNum }}笔</p>
          </li>
          <li>
            <img src="@/assets/images/expenditure.png" />
            <p>
              实退金额
              <el-tooltip class="item" effect="light" content="指订单实际退款金额汇总" placement="right">
                <i class="el-icon-warning" style="color:#D2D2D2;font-size:13px;"></i>
              </el-tooltip>
            </p>
            <p style="color:#333333;font-weight:bold;">
              <span>￥</span>
              <span style="font-size:24px">{{ Business.refundMoney }}</span>
            </p>
            <p class="grey">{{ Business.refundNum }}笔</p>
          </li>
        </el-main>
      </el-container>
      <br />
      <el-container v-if="isHaveWx('全部')" class="container">
        <el-header height="30px" class="header">
          收支数据
          <span>（所选时间段的支付渠道统计）</span>
        </el-header>
        <div class="payData">
          <ul>
            <li v-for="(v,n) in IncomeData" :key="n">
              <div v-if="v.payType !=9 && v.payType !=10 && v.payType !=11 && v.payType !=12 && v.payType !=13 && v.payType !=14 && (v.amount>0 || v.refundAmount>0 ) && v.payType !=15 && v.payType !=16 && v.payType !=17 && v.payType !=18" class="payData_li">
                <h1>{{ v.payTypeName }}</h1>
                <p>
                  <i class="el-icon-plus"></i>
                  <samp>￥</samp>{{ Lib.getValue(1,v.amount) }}
                  <samp>{{ Lib.getValue(2,v.amount) }}</samp>
                  <label>{{ v.payCount || 0 }}笔</label>
                </p>
                <p v-show="v.refundCount >0">
                  <i class="el-icon-minus"></i>
                  <samp>￥</samp>{{ Lib.getValue(1,v.refundAmount) }}
                  <samp>{{ Lib.getValue(2,v.refundAmount) }}</samp>
                  <label>{{ v.refundCount || 0 }}笔</label>
                </p>
              </div>
            </li>
            <li v-if="isHaveWx('微信')">
              <div class="payData_li">
                <h1>
                  微信
                  <el-popover placement="right" trigger="hover">
                    <div style="padding: 10px;">
                      <p>扫码支付时出示微信二维码</p>
                    </div>
                    <i slot="reference" class="el-icon-warning newIcon"></i>
                  </el-popover>
                </h1>
                <p v-if="incomeCompute('微信收入笔数计算')">
                  <i class="el-icon-plus"></i>
                  <samp>￥</samp>{{ incomeCompute('微信收入计算',1) }}
                  <samp>{{ incomeCompute('微信收入计算',2) }}</samp>
                  <label>{{ incomeCompute('微信收入笔数计算') }}笔
                    <el-popover placement="right" trigger="hover">
                      <div style="padding: 10px;">
                        <p v-if="isHaveWx(91)">微信（官方）：+￥{{ incomeCompute('','',9,1) }}</p>
                        <p v-if="isHaveWx(91)">{{ incomeCompute('','',9,2) }}笔</p>
                        <p v-if="isHaveWx(111)">微信（通联）：+￥{{ incomeCompute('','',11,1) }}</p>
                        <p v-if="isHaveWx(111)">{{ incomeCompute('','',11,2) }}笔</p>
                        <p v-if="isHaveWx(131)">微信（翼支付）：+￥{{ incomeCompute('','',13,1) }}</p>
                        <p v-if="isHaveWx(131)">{{ incomeCompute('','',13,2) }}笔</p>
                        <p v-if="isHaveWx(151)">微信（合利宝）：+￥{{ incomeCompute('','',15,1) }}</p>
                        <p v-if="isHaveWx(151)">{{ incomeCompute('','',15,2) }}笔</p>
                        <p v-if="isHaveWx(171)">微信（收银宝）：+￥{{ incomeCompute('','',17,1) }}</p>
                        <p v-if="isHaveWx(171)">{{ incomeCompute('','',17,2) }}笔</p>
                      </div>
                      <i slot="reference" class="el-icon-warning newIcon"></i>
                    </el-popover>
                  </label>
                </p>
                <p v-if="incomeCompute('微信支出笔数计算')">
                  <i class="el-icon-minus"></i>
                  <samp>￥</samp>{{ incomeCompute('微信支出计算',1) }}
                  <samp>{{ incomeCompute('微信支出计算',2) }}</samp>
                  <label>{{ incomeCompute('微信支出笔数计算') }}笔
                    <el-popover placement="right" trigger="hover">
                      <div style="padding: 10px;">
                        <p v-if="isHaveWx(93)">微信（官方）：-￥{{ incomeCompute('','',9,3) }}</p>
                        <p v-if="isHaveWx(93)">{{ incomeCompute('','',9,4) }}笔</p>
                        <p v-if="isHaveWx(113)">微信（通联）：-￥{{ incomeCompute('','',11,3) }}</p>
                        <p v-if="isHaveWx(113)">{{ incomeCompute('','',11,4) }}笔</p>
                        <p v-if="isHaveWx(133)">微信（翼支付）：-￥{{ incomeCompute('','',13,3) }}</p>
                        <p v-if="isHaveWx(133)">{{ incomeCompute('','',13,4) }}笔</p>
                        <p v-if="isHaveWx(153)">微信（合利宝）：-￥{{ incomeCompute('','',15,3) }}</p>
                        <p v-if="isHaveWx(153)">{{ incomeCompute('','',15,4) }}笔</p>
                        <p v-if="isHaveWx(173)">微信（收银宝）：-￥{{ incomeCompute('','',17,3) }}</p>
                        <p v-if="isHaveWx(173)">{{ incomeCompute('','',17,4) }}笔</p>
                      </div>
                      <i slot="reference" class="el-icon-warning newIcon"></i>
                    </el-popover>
                  </label>
                </p>
              </div>
            </li>
            <li v-if="isHaveWx('支付宝')">
              <div class="payData_li">
                <h1>
                  支付宝
                  <el-popover placement="right" trigger="hover">
                    <div style="padding: 10px;">
                      <p>扫码支付时出示支付宝二维码</p>
                    </div>
                    <i slot="reference" class="el-icon-warning newIcon"></i>
                  </el-popover>
                </h1>
                <p v-if="incomeCompute('支付宝收入笔数计算')">
                  <i class="el-icon-plus"></i>
                  <samp>￥</samp>{{ incomeCompute('支付宝收入计算',1) }}
                  <samp>{{ incomeCompute('支付宝收入计算',2) }}</samp>
                  <label>{{ incomeCompute('支付宝收入笔数计算') }}笔
                    <el-popover placement="right" trigger="hover">
                      <div style="padding: 10px;">
                        <p v-if="isHaveWx(101)">支付宝（官方）：+￥{{ incomeCompute('','',10,1) }}</p>
                        <p v-if="isHaveWx(101)">{{ incomeCompute('','',10,2) }}笔</p>
                        <p v-if="isHaveWx(121)">支付宝（通联）：+￥{{ incomeCompute('','',12,1) }}</p>
                        <p v-if="isHaveWx(121)">{{ incomeCompute('','',12,2) }}笔</p>
                        <p v-if="isHaveWx(141)">支付宝（翼支付）：+￥{{ incomeCompute('','',14,1) }}</p>
                        <p v-if="isHaveWx(141)">{{ incomeCompute('','',14,2) }}笔</p>
                        <p v-if="isHaveWx(161)">支付宝（合利宝）：+￥{{ incomeCompute('','',16,1) }}</p>
                        <p v-if="isHaveWx(161)">{{ incomeCompute('','',16,2) }}笔</p>
                        <p v-if="isHaveWx(181)">支付宝（收银宝）：+￥{{ incomeCompute('','',18,1) }}</p>
                        <p v-if="isHaveWx(181)">{{ incomeCompute('','',18,2) }}笔</p>
                      </div>
                      <i slot="reference" class="el-icon-warning newIcon"></i>
                    </el-popover>
                  </label>
                </p>
                <p v-if="incomeCompute('支付宝支出笔数计算')">
                  <i class="el-icon-minus"></i>
                  <samp>￥</samp>{{ incomeCompute('支付宝支出计算',1) }}
                  <samp>{{ incomeCompute('支付宝支出计算',2) }}</samp>
                  <label>{{ incomeCompute('支付宝支出笔数计算') }}笔
                    <el-popover placement="right" trigger="hover">
                      <div style="padding: 10px;">
                        <p v-if="isHaveWx(103)">支付宝（官方）：-￥{{ incomeCompute('','',10,3) }}</p>
                        <p v-if="isHaveWx(103)">{{ incomeCompute('','',10,4) }}笔</p>
                        <p v-if="isHaveWx(123)">支付宝（通联）：-￥{{ incomeCompute('','',12,3) }}</p>
                        <p v-if="isHaveWx(123)">{{ incomeCompute('','',12,4) }}笔</p>
                        <p v-if="isHaveWx(143)">支付宝（翼支付）：-￥{{ incomeCompute('','',14,3) }}</p>
                        <p v-if="isHaveWx(143)">{{ incomeCompute('','',14,4) }}笔</p>
                        <p v-if="isHaveWx(163)">支付宝（合利宝）：-￥{{ incomeCompute('','',16,3) }}</p>
                        <p v-if="isHaveWx(163)">{{ incomeCompute('','',16,4) }}笔</p>
                        <p v-if="isHaveWx(183)">支付宝（收银宝）：-￥{{ incomeCompute('','',18,3) }}</p>
                        <p v-if="isHaveWx(183)">{{ incomeCompute('','',18,4) }}笔</p>
                      </div>
                      <i slot="reference" class="el-icon-warning newIcon"></i>
                    </el-popover>
                  </label>
                </p>
              </div>
            </li>
          </ul>
        </div>
      </el-container>
      <br />
      <div class="tic">
        <el-tabs v-model="activeName2" type="card">
          <el-tab-pane label="收入明细" name="first">
            <el-table tooltip-effect="light" :data="pagedata" style="width: 100%">
              <el-table-column prop="dateTime" label="日期"></el-table-column>
              <el-table-column prop="serverItemIncome" label="项目销售收入（元）"></el-table-column>
              <el-table-column prop="productIncome" label="产品销售收入（元）"></el-table-column>
              <el-table-column prop="vipCardIncome" label="套餐销售收入（元）"></el-table-column>
              <el-table-column prop="fastIncome" label="快捷收银（元）"></el-table-column>
              <el-table-column prop="countMoney" label="应收合计（元）"></el-table-column>
              <el-table-column label="操作" width="180">
                <template slot-scope="scope">
                  <el-button type="primary" size="mini" @click="handleClick(scope.row)">详情</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination :current-page.sync="currentPage" background layout="prev, pager, next" :total="total" @current-change="pageDataFn"></el-pagination>
          </el-tab-pane>
          <el-tab-pane label="优惠明细" name="second">
            <el-table tooltip-effect="light" :data="pagedata" style="width: 100%">
              <el-table-column prop="dateTime" label="日期" min-width="100"></el-table-column>
              <el-table-column prop="orderChangePrice" label="整单改价（元）" min-width="120"></el-table-column>
              <el-table-column prop="revisionPrice" label="改价优惠（元）" min-width="120"></el-table-column>
              <el-table-column prop="memberPrice" label="会员优惠（元）" min-width="120"></el-table-column>
              <el-table-column prop="giftPrice" label="赠送优惠（元）" min-width="120"></el-table-column>
              <el-table-column prop="activityPrice" label="活动优惠（元）" min-width="120"></el-table-column>
              <el-table-column prop="couponPrice" label="优惠券抵扣（元）" min-width="140"></el-table-column>
              <!-- <el-table-column prop="vipCardPrice" label="套餐划扣（元）" min-width="120"></el-table-column> -->
              <el-table-column prop="integralPrice" label="积分抵扣（元）" min-width="120"></el-table-column>
              <el-table-column prop="deductPrice" label="粉币抵扣（元）" min-width="120"></el-table-column>
              <!-- <el-table-column prop="YZDeductPrice" label="样子特权折扣（元）" min-width="160"></el-table-column>
                        <el-table-column prop="YZIntegralPrice" label="样子积分（元）" min-width="120"></el-table-column>
                        <el-table-column prop="YZPacketPrice" label="样子红包（元）" min-width="120"></el-table-column> -->
              <el-table-column prop="totle" label="合计（元）" min-width="120"></el-table-column>

              <el-table-column label="操作" width="80" fixed="right">
                <template slot-scope="scope">
                  <el-button type="primary" size="mini" @click="handleClick(scope.row)">详情</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination :current-page.sync="currentPage" background layout="prev, pager, next" :total="total" @current-change="pageDataFn"></el-pagination>
          </el-tab-pane>
          <el-tab-pane label="划扣金额明细" name="third">
            <el-table tooltip-effect="light" :data="pagedata" style="width: 100%">
              <el-table-column prop="dateTime" label="日期"></el-table-column>
              <el-table-column prop="vipCardItemDeduct" label="项目划扣（元）"></el-table-column>
              <el-table-column prop="vipCardProductDeduct" label="产品划扣（元）"></el-table-column>
              <el-table-column prop="memberCardDeduct" label="会员卡划扣（元）"></el-table-column>
              <el-table-column prop="goodsDeduct" label="货款划扣（元）"></el-table-column>
              <el-table-column prop="totle" label="合计（元）"></el-table-column>
              <el-table-column label="操作" width="180">
                <template slot-scope="scope">
                  <el-button type="primary" size="mini" @click="handleClick(scope.row)">详情</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination :current-page.sync="currentPage" background layout="prev, pager, next" :total="total" @current-change="pageDataFn"></el-pagination>
          </el-tab-pane>
          <el-tab-pane label="应收欠款明细" name="fourth">
            <el-table tooltip-effect="light" :data="pagedata" style="width: 100%">
              <el-table-column prop="dateTime" label="日期"></el-table-column>
              <el-table-column prop="creditMoney" label="赊账金额（元）"></el-table-column>
              <el-table-column prop="debtMoney" label="欠款金额（元）"></el-table-column>
              <el-table-column prop="totle" label="合计（元）"></el-table-column>
              <el-table-column label="操作" width="180">
                <template slot-scope="scope">
                  <el-button type="primary" size="mini" @click="handleClick(scope.row)">详情</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination :current-page.sync="currentPage" background layout="prev, pager, next" :total="total" @current-change="pageDataFn"></el-pagination>
          </el-tab-pane>
          <el-tab-pane v-loading="loading" label="支付明细" name="fifth">
            <el-table ref="table" tooltip-effect="light" :data="pagedata" style="width: 100%">
              <el-table-column prop="dateTime" label="日期" width="120"></el-table-column>
              <el-table-column v-for="(item,index) of tableData.ListTiele" :key="index" min-width="150" :label="item.payTypeName">
                <template slot-scope="scope">
                  <div v-for="(v, n) in scope.row.list" v-show="item.payTypeName == v.payTypeName" :key="n" style="line-height: 28px;">
                    {{ item.payTypeName == v.payTypeName ?v.amount:0 }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="totalAmount" label="合计（元）" width="120"></el-table-column>
              <el-table-column label="操作" width="80" fixed="right">
                <template slot-scope="scope">
                  <el-button type="primary" size="mini" @click="handleClick(scope.row)">详情</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination :current-page.sync="currentPage" background layout="prev, pager, next" :total="total" @current-change="pageDataFn"></el-pagination>
          </el-tab-pane>
          <el-tab-pane label="退款明细" name="sixth">
            <el-table :data="pagedata" style="width: 100%">
              <el-table-column prop="dateTime" label="日期"></el-table-column>
              <el-table-column prop="cash" label="现金（元）"></el-table-column>
              <el-table-column prop="vipCard" label="会员卡（元）"></el-table-column>
              <el-table-column prop="weChat" label="微信（元）"></el-table-column>
              <el-table-column prop="alipay" label="支付宝（元）"></el-table-column>
              <el-table-column prop="refundTotle" label="退款合计（元）"></el-table-column>
              <el-table-column label="操作" width="180">
                <template slot-scope="scope">
                  <el-button type="primary" size="mini" @click="handleClick(scope.row)">详情</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination :current-page.sync="currentPage" background layout="prev, pager, next" :total="total" @current-change="pageDataFn"></el-pagination>
          </el-tab-pane>
        </el-tabs>
        <div class="button_group">
          <el-button type="primary" size="small" @click="onExportTable">导出报表</el-button>
          <el-button type="primary" size="small" @click="onPrint">打印报表</el-button>
        </div>
      </div>
    </div>
    <gt-noneData v-else :title="'暂无权限，请联系管理员分配权限'" :is-no-permission="true"></gt-noneData>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import api from '../../api/index.js';

export default {
  data() {
    return {
      date: [
        dayjs()
          .subtract(30, 'day')
          .format('YYYY-MM-DD'),
        dayjs().format('YYYY-MM-DD')
      ],
      activeName2: 'first',
      tableData: [],
      pagedata: [],
      total: 0,
      expireTimeOption: {
        disabledDate(date) {
          return date.getTime() > Date.now();
        }
      },
      currentPage: 1,
      Business: {
        incomeMoney: 0,
        discountMoney: 0,
        deductMoney: 0,
        dueMoney: 0,
        creditMoney: 0,
        debtMoney: 0,
        realMoney: 0,
        refundMoney: 0
      },
      IncomeData: [],
      Title: '',
      loading: false,
      value: '1'
    };
  },
  watch: {
    activeName2(val) {
      this.currentPage = 1;
      this.onGetPaymentDtailsTitle();
      if (val === 'first') {
        this.onGetIncomeDetail();
      }
      if (val === 'second') {
        this.onGetDiscoutDtails();
      }
      if (val === 'third') {
        this.onGetDeductDtails();
      }
      if (val === 'fourth') {
        this.onGetDebtDtails();
      }
      if (val === 'fifth') {
        this.onGetPaymentDtails();
      }
      if (val === 'sixth') {
        this.onGetRefundtDtails();
        // 退款明细
      }
    },
    value() {
      this.onGetBusiness();
      this.getIncomeData();
      const val = this.activeName2;
      this.currentPage = 1;
      this.onGetPaymentDtailsTitle();
      if (val === 'first') {
        this.onGetIncomeDetail();
      }
      if (val === 'second') {
        this.onGetDiscoutDtails();
      }
      if (val === 'third') {
        this.onGetDeductDtails();
      }
      if (val === 'fourth') {
        this.onGetDebtDtails();
      }
      if (val === 'fifth') {
        this.onGetPaymentDtails();
      }
      if (val === 'sixth') {
        this.onGetRefundtDtails();
        // 退款明细
      }
    }
  },
  // mounted() {
  //     this.onGetIncomeDetail();
  //     this.onGetBusiness();
  // },
  activated() {
    this.currentPage = 1;
    this.onGetBusiness();
    this.getIncomeData();
    this.onGetPaymentDtailsTitle();
    if (this.activeName2 === 'first') {
      this.onGetIncomeDetail();
    }
    if (this.activeName2 === 'second') {
      this.onGetDiscoutDtails();
    }
    if (this.activeName2 === 'third') {
      this.onGetDeductDtails();
    }
    if (this.activeName2 === 'fourth') {
      this.onGetDebtDtails();
    }
    if (this.activeName2 === 'fifth') {
      this.onGetPaymentDtails();
    }
    if (this.activeName2 === 'sixth') {
      this.onGetRefundtDtails();
      // 退款明细
    }
  },
  methods: {
    isHaveWx(val) {
      const vm = this;
      let status = 0;
      vm.IncomeData.forEach((v) => {
        if (val == '微信') {
          if ((v.payType == 9 || v.payType == 11 || v.payType == 13 || v.payType == 15 || v.payType == 17) && v.amount) status++;
        } else if (val == '全部') {
          if (v.amount || v.refundAmount) status++;
        } else if (val == '支付宝') {
          if ((v.payType == 10 || v.payType == 12 || v.payType == 14 || v.payType == 16 || v.payType == 18) && v.amount) status++;
        } else if (val == 91 && v.payType == 9 && v.amount) status++;
        else if (val == 93 && v.payType == 9 && v.refundAmount) status++;
        else if (val == 101 && v.payType == 10 && v.amount) status++;
        else if (val == 103 && v.payType == 10 && v.refundAmount) status++;
        else if (val == 111 && v.payType == 11 && v.amount) status++;
        else if (val == 113 && v.payType == 11 && v.refundAmount) status++;
        else if (val == 121 && v.payType == 12 && v.amount) status++;
        else if (val == 123 && v.payType == 12 && v.refundAmount) status++;
        else if (val == 131 && v.payType == 13 && v.amount) status++;
        else if (val == 133 && v.payType == 13 && v.refundAmount) status++;
        else if (val == 141 && v.payType == 14 && v.amount) status++;
        else if (val == 143 && v.payType == 14 && v.refundAmount) status++;
        else if (val == 151 && v.payType == 15 && v.amount) status++;
        else if (val == 153 && v.payType == 15 && v.refundAmount) status++;
        else if (val == 161 && v.payType == 16 && v.amount) status++;
        else if (val == 163 && v.payType == 16 && v.refundAmount) status++;
        else if (val == 171 && v.payType == 17 && v.amount) status++;
        else if (val == 173 && v.payType == 17 && v.refundAmount) status++;
        else if (val == 181 && v.payType == 18 && v.amount) status++;
        else if (val == 183 && v.payType == 18 && v.refundAmount) status++;
      });
      return status > 0;
    },
    incomeCompute(name, num, type, status) {
      const vm = this;
      let wxsrjs = 0;
      let wxsrbsjs = 0;
      let wxzcjs = 0;
      let wxzcbsjs = 0;
      let zfbsrjs = 0;
      let zfbsrbsjs = 0;
      let zfbzcjs = 0;
      let zfbzcbsjs = 0;
      let amount = 0;
      let payCount = 0;
      let refundAmount = 0;
      let refundCount = 0;
      vm.IncomeData.forEach((v) => {
        if (v.payType == 9 || v.payType == 11 || v.payType == 13 || v.payType == 15 || v.payType == 17) {
          wxsrjs += (v.amount ? v.amount * 1 : 0);
          wxsrbsjs += (v.payCount ? v.payCount * 1 : 0);
          wxzcjs += (v.refundAmount ? v.refundAmount * 1 : 0);
          wxzcbsjs += (v.refundCount ? v.refundCount * 1 : 0);
        }
        if (v.payType == 10 || v.payType == 12 || v.payType == 14 || v.payType == 16 || v.payType == 18) {
          zfbsrjs += (v.amount ? v.amount * 1 : 0);
          zfbsrbsjs += (v.payCount ? v.payCount * 1 : 0);
          zfbzcjs += (v.refundAmount ? v.refundAmount * 1 : 0);
          zfbzcbsjs += (v.refundCount ? v.refundCount * 1 : 0);
        }
        if (v.payType == type) {
          amount = v.amount ? (v.amount * 1) : 0;
          payCount = v.payCount ? (v.payCount * 1) : 0;
          refundAmount = v.refundAmount ? (v.refundAmount * 1) : 0;
          refundCount = v.refundCount ? (v.refundCount * 1) : 0;
        }
      });
      if (name === '微信收入计算') return vm.Lib.getValue(num, wxsrjs);
      if (name === '微信收入笔数计算') return wxsrbsjs;
      if (name === '微信支出计算') return vm.Lib.getValue(num, wxzcjs);
      if (name === '微信支出笔数计算') return wxzcbsjs;
      if (name === '支付宝收入计算') return vm.Lib.getValue(num, zfbsrjs);
      if (name === '支付宝收入笔数计算') return zfbsrbsjs;
      if (name === '支付宝支出计算') return vm.Lib.getValue(num, zfbzcjs);
      if (name === '支付宝支出笔数计算') return zfbzcbsjs;
      if (type) return status == 1 ? amount : status == 2 ? payCount : status == 3 ? refundAmount : refundCount;
    },
    // 获取 营业概况头部数据
    onGetBusiness() {
      const data = {
        beginTime: this.date[0],
        endTime: this.date[1],
        mainId: sessionStorage.getItem('mainId'),
        timeCountType: this.value
      };
      api.getBusiness(data).then((res) => {
        this.Business = res.data;
      });
    },
    // 获取 营业概况头部数据
    getIncomeData() {
      const data = {
        beginTime: this.date[0],
        endTime: this.date[1],
        mainId: sessionStorage.getItem('mainId'),
        timeCountType: this.value
      };
      api.getIncomeInfo(data).then((res) => {
        this.IncomeData = res.data;
      });
    },
    // 获取 收入明细
    onGetIncomeDetail() {
      const data = {
        beginTime: this.date[0],
        endTime: this.date[1],
        mainId: sessionStorage.getItem('mainId'),
        timeCountType: this.value
      };
      api.getIncomeDetail(data).then((res) => {
        this.total = Object.keys(res.data).length;
        const arr = [];
        for (const key in res.data) {
          arr.push(res.data[key]);
        }

        this.tableData = arr;
        this.tableData.ListTiele = this.Title;
        this.pageDataFn(1);
      });
    },
    // 获取 优惠明细
    onGetDiscoutDtails() {
      const data = {
        beginTime: this.date[0],
        endTime: this.date[1],
        mainId: sessionStorage.getItem('mainId'),
        timeCountType: this.value
      };
      api.getDiscoutDtails(data).then((res) => {
        this.total = Object.keys(res.data).length;
        const arr = [];
        for (const key in res.data) {
          arr.push(res.data[key]);
        }

        this.tableData = arr;
        this.tableData.ListTiele = this.Title;
        this.pageDataFn(1);
      });
    },
    // 获取 划扣金额明细
    onGetDeductDtails() {
      const data = {
        beginTime: this.date[0],
        endTime: this.date[1],
        mainId: sessionStorage.getItem('mainId'),
        timeCountType: this.value
      };
      api.getDeductDtails(data).then((res) => {
        this.total = Object.keys(res.data).length;
        const arr = [];
        for (const key in res.data) {
          arr.push(res.data[key]);
        }
        this.tableData = arr;
        this.tableData.ListTiele = this.Title;
        this.pageDataFn(1);
      });
    },
    // 获取 应收欠款明细
    onGetDebtDtails() {
      const data = {
        beginTime: this.date[0],
        endTime: this.date[1],
        mainId: sessionStorage.getItem('mainId'),
        timeCountType: this.value
      };
      api.getDebtDtails(data).then((res) => {
        this.total = Object.keys(res.data).length;
        const arr = [];
        for (const key in res.data) {
          arr.push(res.data[key]);
        }
        this.tableData = arr;
        this.tableData.ListTiele = this.Title;
        this.pageDataFn(1);
      });
    },
    // 获取支付明细表头
    onGetPaymentDtailsTitle() {
      const data = {
        mainId: sessionStorage.getItem('mainId'),
        beginTime: this.date[0],
        endTime: this.date[1],
        timeCountType: this.value
      };
      api.getPayDetailsTitle(data).then((res) => {
        this.Title = res.data;
      });
    },
    // 获取 支付明细
    onGetPaymentDtails(val) {
      this.loading = true;
      const data = {
        pageNum: val,
        pageSize: 999999,
        beginTime: this.date[0],
        endTime: this.date[1],
        mainId: sessionStorage.getItem('mainId'),
        timeCountType: this.value
      };
      api.getPayDetails(data).then((res) => {
        this.total = res.data.total;
        const arr = [];
        res.data.records.forEach((a) => {
          arr.push(a);
        });
        this.tableData = arr;
        this.tableData.ListTiele = this.Title;
        this.pageDataFn(1);
        this.loading = false;
      });
    },
    // 获取 退款明细
    onGetRefundtDtails() {
      const data = {
        beginTime: this.date[0],
        endTime: this.date[1],
        mainId: sessionStorage.getItem('mainId'),
        timeCountType: this.value
      };
      api.getRefundDtails(data).then((res) => {
        this.total = Object.keys(res.data).length;
        const arr = [];
        for (const key in res.data) {
          arr.push(res.data[key]);
        }
        this.tableData = arr;
        this.tableData.ListTiele = this.Title;
        this.pageDataFn(1);
      });
    },
    // 分页数据处理函数
    pageDataFn(number) {
      // 处于第几页 number
      // 保存每页数据的函数
      const pagedata = [];
      // pagesize=10 每页条数
      // 设置开始
      const start = 10 * number - 10;
      // 设置结束长度
      let end = 10 * number; // 长度判断 //所有分页数据 this.tableData
      end = end > this.tableData.length ? this.tableData.length : end;
      for (let i = start; i < end; i++) {
        // 所有分页数据 this.tableData
        pagedata.push(this.tableData[i]);
      }
      this.pagedata = pagedata;
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    },
    // 切换时间
    onChangeTime() {
      this.onGetBusiness();
      this.getIncomeData();
      this.currentPage = 1;
      this.onGetPaymentDtailsTitle();
      if (this.activeName2 === 'first') {
        this.onGetIncomeDetail();
      }
      if (this.activeName2 === 'second') {
        this.onGetDiscoutDtails();
      }
      if (this.activeName2 === 'third') {
        this.onGetDeductDtails();
      }
      if (this.activeName2 === 'fourth') {
        this.onGetDebtDtails();
      }
      if (this.activeName2 === 'fifth') {
        this.onGetPaymentDtails();
      }
      if (this.activeName2 === 'sixth') {
        this.onGetRefundtDtails();
        // 退款明细
      }
    },
    handleClick(row) {
      if (this.Lib.checkPower('beauty-5-ckyygkxq') == false) return;
      const { dateTime } = row;
      if (this.activeName2 === 'first') {
        this.$router.push({
          name: 'finance-analyse',
          params: {
            word: '收入详情',
            date: dateTime,
            timeCountType: this.value
          }
        });
      }
      if (this.activeName2 === 'second') {
        this.$router.push({
          name: 'finance-analyse',
          params: {
            word: '优惠详情',
            date: dateTime,
            timeCountType: this.value
          }
        });
      }
      if (this.activeName2 === 'third') {
        this.$router.push({
          name: 'finance-analyse',
          params: {
            word: '划扣金额详情',
            date: dateTime,
            timeCountType: this.value
          }
        });
      }
      if (this.activeName2 === 'fourth') {
        this.$router.push({
          name: 'finance-analyse',
          params: {
            word: '应收欠款详情',
            date: dateTime,
            timeCountType: this.value
          }
        });
      }
      if (this.activeName2 === 'fifth') {
        this.$router.push({
          name: 'finance-analyse',
          params: {
            word: '支付详情',
            date: dateTime,
            timeCountType: this.value
          }
        });
      }
      if (this.activeName2 === 'sixth') {
        this.$router.push({
          name: 'finance-analyse',
          params: {
            word: '退款详情',
            date: dateTime,
            timeCountType: this.value
          }
        });
      }
    },
    // 导出
    onExportTable() {
      if (this.Lib.checkPower('beauty-4-dcyygkbb2') == false) return;
      if (this.activeName2 === 'first') {
        this.$root.$children[0].fatherExport('exportIncomeDetail', this.date[0], this.date[1], this.value);
      }
      if (this.activeName2 === 'second') {
        this.$root.$children[0].fatherExport('exportDiscoutDtails', this.date[0], this.date[1], this.value);
      }
      if (this.activeName2 === 'third') {
        this.$root.$children[0].fatherExport('exportDeductDtails', this.date[0], this.date[1], this.value);
      }
      if (this.activeName2 === 'fourth') {
        this.$root.$children[0].fatherExport('exportDebtDtails', this.date[0], this.date[1], this.value);
      }
      if (this.activeName2 === 'fifth') {
        this.$root.$children[0].fatherExport('exportPayDetails', this.date[0], this.date[1], this.value);
        // 支付明细
      }
      if (this.activeName2 === 'sixth') {
        this.$root.$children[0].fatherExport('exportRefundDtails', this.date[0], this.date[1], this.value);
        // 退款明细
      }
    },
    // 打印
    onPrint() {
      if (this.Lib.checkPower('beauty-4-dyyygkbb2') == false) return;
      if (this.activeName2 === 'first') {
        this.$print({
          data: this.tableData,
          title: '收入明细',
          table_tol: [
            { name: '日期', prop: 'dateTime' },
            {
              name: '项目销售收入（元）',
              prop: 'serverItemIncome'
            },
            { name: '产品销售收入（元）', prop: 'productIncome' },
            { name: '套餐销售收入（元）', prop: 'vipCardIncome' },
            { name: '快捷收银（元）', prop: 'fastIncome' },
            { name: '应收合计（元）', prop: 'countMoney' }
          ]
        });
      }
      if (this.activeName2 === 'second') {
        this.$print({
          data: this.tableData,
          title: '优惠明细',
          table_tol: [
            { name: '日期', prop: 'dateTime' },
            {
              name: '改价优惠（元）',
              prop: 'revisionPrice'
            },
            { name: '会员优惠（元）', prop: 'memberPrice' },
            { name: '优惠券折扣（元）', prop: 'couponPrice' },
            { name: '套餐划扣（元）', prop: 'vipCardPrice' },
            { name: '积分抵扣（元）', prop: 'integralPrice' },
            { name: '粉币抵扣（元）', prop: 'deductPrice' },
            { name: '合计（元）', prop: 'totle' }
          ]
        });
      }
      if (this.activeName2 === 'third') {
        this.$print({
          data: this.tableData,
          title: '划扣金额明细',
          table_tol: [
            { name: '日期', prop: 'dateTime' },
            {
              name: '项目划扣（元）',
              prop: 'vipCardItemDeduct'
            },
            {
              name: '产品划扣（元）',
              prop: 'vipCardProductDeduct'
            },
            { name: '合计（元）', prop: 'totle' }
          ]
        });
      }
      if (this.activeName2 === 'fourth') {
        this.$print({
          data: this.tableData,
          title: '应收欠款明细',
          table_tol: [
            { name: '日期', prop: 'dateTime' },
            {
              name: '赊账金额（元）',
              prop: 'creditMoney'
            },
            { name: '欠款金额（元）', prop: 'debtMoney' },
            { name: '合计（元）', prop: 'totle' }
          ]
        });
      }
      if (this.activeName2 === 'fifth') {
        const arr = [{
          name: '日期', prop: 'dateTime'
        }];
        this.tableData.forEach((a) => {
          a.list.forEach((b) => {
            a[`pay_${b.payType}`] = b.amount;
          });
        });
        this.tableData[0].list.forEach((c) => {
          const obj = {};
          obj.name = c.payTypeName;
          obj.prop = `pay_${c.payType}`;
          arr.push(obj);
        });
        arr.push({ name: '合计（元）', prop: 'totalAmount' });
        this.$print({
          data: this.tableData,
          title: '支付明细',
          table_tol: arr
        });
      }

      if (this.activeName2 === 'sixth') {
        this.$print({
          data: this.tableData,
          title: '退款明细',
          table_tol: [
            { name: '日期', prop: 'dateTime' },
            { name: '现金（元）', prop: 'cash' },
            { name: '会员卡（元）', prop: 'vipCard' },
            { name: '微信（元）', prop: 'weChat' },
            { name: '支付宝（元）', prop: 'alipay' },
            { name: '合计（元）', prop: 'refundTotle' }
          ]
        });
      }
    }
  }
};
</script>
<style scoped>
.container {
  border: 1px solid rgba(216, 220, 229, 1);
}
.header {
  height: 46px !important;
  background: rgba(245, 247, 250, 1);
  line-height: 46px;
  font-size: 16px;
  color: #818691;
  font-weight: bold;
}
.main {
  display: flex !important;
  list-style: none;
  justify-content: space-around;
  height: 253px;
}
.main > li {
  text-align: center;
  line-height: 28px;
}
.main > li > p:first-of-type {
  margin-left: 14px;
}
.main > li > p:nth-child(3) {
  margin-right: 14px;
}
.grey {
  color: #999999;
  font-size: 14px;
}
.tic {
  position: relative;
}
.button_group {
  position: absolute;
  right: 0;
  top: 0;
}
</style>
<style lang="less" scoped>
.payData {
  margin: 10px;
  background-color: #f5f5f5;
  border-radius: 10px;
  overflow-y: auto;
  max-height: 360px;
  ul {
    list-style-type: none;
    margin-right: 30px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    padding-bottom: 10px;
    .payData_li {
      padding-top: 15px;
      flex: 1;
      min-width: 336px;
      max-width: 336px;
      .newIcon {
        color: #d2d2d2;
        font-size: 13px;
        padding-left: 5px;
        font-weight: 500;
      }
      h1 {
        height: 16px;
        line-height: 16px;
        font-size: 16px;
        padding-left: 10px;
        margin: 0 0 10px 30px;
        color: #333;
        border-left: 4px solid #409eff;
      }
      p {
        font-size: 24px;
        color: #333;
        height: 24px;
        line-height: 24px;
        padding: 10px 0;
        margin-left: 30px;
        i {
          padding-left: 14px;
          font-weight: 600;
          font-size: 12px;
          position: relative;
          top: -1px;
        }
        samp {
          font-size: 14px;
        }
        label {
          padding-left: 20px;
          float: right;
          font-size: 14px;
          color: #999;
          line-height: 30px;
        }
      }
    }
  }
}
</style>
